// extracted by mini-css-extract-plugin
module.exports = {"productList":"productList_productList__vdEW2"};